import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { projects } from '../mock';
import Footer from '../components/Footer';

const Projects = () => {
  useEffect(() => {
    // Set page-specific meta tags
    document.title = 'Projekter - Fryd! | Træarbejde og håndværk';
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Se vores udvalgte projekter i træ. Fra Tolvkanten til Rosenborg - hvert projekt er udført med præcision, faglighed og respekt for materialet.');
    }
    
    // Set canonical URL
    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', 'https://ffryd.dk/projekter');
  }, []);

  return (
    <div className="min-h-screen bg-neutral-50">
      <div className="pt-32 pb-20 px-8 md:px-16">
        <div className="max-w-7xl mx-auto">
          {/* Header */}
          <div className="mb-16">
            <h1 className="text-5xl md:text-7xl font-light text-gray-900">
              Projekter
            </h1>
          </div>

          {/* Projects Grid - 2 columns like A MGMT */}
          <div className="grid md:grid-cols-2 gap-8">
            {projects.map((project) => (
              <Link
                key={project.id}
                to={`/projekter/${project.slug}`}
                className="group cursor-pointer block"
                data-testid={`project-link-${project.id}`}
              >
                <div className="relative overflow-hidden aspect-[3/4] mb-4">
                  <img
                    src={project.image}
                    alt={project.title || project.location || 'Projekt'}
                    className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                  />
                </div>
                <div>
                  <p className="text-gray-900 text-lg font-light">{project.location}</p>
                </div>
              </Link>
            ))}
          </div>

          {/* Contact CTA Section */}
          <div className="mt-32 pt-16 border-t border-gray-200">
            <div className="max-w-2xl">
              <h2 className="text-3xl md:text-4xl font-light text-gray-900 mb-6">
                Har du et projekt i tankerne?
              </h2>
              <p className="text-lg text-gray-600 font-light leading-relaxed mb-10">
                Vi hjælper med at føre arkitektoniske idéer ud i livet. Fortæl os om dit projekt, så tager vi en snak om mulighederne.
              </p>
              <Link
                to="/kontakt"
                className="inline-flex items-center space-x-3 text-gray-900 text-lg font-light border-b border-gray-900 pb-2 hover:text-gray-600 hover:border-gray-600 transition-all duration-300 group"
              >
                <span>Fortæl os om dit projekt</span>
                <ArrowRight className="w-5 h-5 group-hover:translate-x-2 transition-transform duration-300" />
              </Link>
            </div>
          </div>
        </div>
      </div>

      {/* Footer Contact Section */}
      <Footer />
    </div>
  );
};

export default Projects;
